import React from 'react';

import { Stack } from 'react-bootstrap';
import {
  BsChevronDoubleLeft,
  BsChevronDoubleRight,
  BsChevronLeft,
  BsChevronRight,
} from 'react-icons/bs';

import SVButton from 'components/elements/SVButton';

interface PDFNavigationProps {
  currentPage: number;
  totalPages: number;
  handlePageChange: (page: number) => void;
}

const PDFNavigation: React.FC<PDFNavigationProps> = ({
  currentPage,
  totalPages,
  handlePageChange,
}) => (
  <Stack className="justify-content-center" direction="horizontal" gap={3}>
    <SVButton disabled={currentPage <= 1} onClick={() => handlePageChange(1)}>
      <BsChevronDoubleLeft />
    </SVButton>
    <SVButton
      disabled={currentPage <= 1}
      onClick={() => handlePageChange(currentPage - 1)}
    >
      <BsChevronLeft />
    </SVButton>
    <span style={{ margin: '0px .5rem' }}>
      {`${currentPage} / ${totalPages}`}
    </span>
    <SVButton
      disabled={currentPage >= totalPages}
      onClick={() => handlePageChange(currentPage + 1)}
    >
      <BsChevronRight />
    </SVButton>
    <SVButton
      disabled={currentPage >= totalPages}
      onClick={() => handlePageChange(totalPages)}
    >
      <BsChevronDoubleRight />
    </SVButton>
  </Stack>
);

export default PDFNavigation;
